module.exports = {
  "pageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": [
        "detail"
      ],
      "subscreen": [
        "performance",
        "optimization",
        "personalization",
        "personalization-results",
        "variations",
        "smart-content"
      ],
      "pageType": [
        "LANDING_PAGE",
        "SITE_PAGE"
      ]
    },
    "namespace": "page-details-ui",
    "version": "1"
  },
  "actionsInteraction": {
    "name": "page-details-interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "page-details-ui",
    "version": "1"
  },
  "adsPanelInteraction": {
    "name": "page-details-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-ads-onboarding-link",
        "clicked-settings-url",
        "clicked-create-website-traffic-ad"
      ],
      "network": [
        "FACEBOOK",
        "LINKEDIN",
        "ADWORDS",
        "NONE"
      ],
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "page-details-ui",
    "version": "1"
  },
  "mabInteraction": {
    "name": "page-details-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-end-test-button",
        "end-test"
      ],
      "pageType": [
        "LANDING_PAGE",
        "SITE_PAGE"
      ],
      "status": {
        "type": [
          "success",
          "fail"
        ],
        "isOptional": true
      },
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "page-details-ui",
    "version": "1"
  },
  "contentOptimizationInteraction": {
    "name": "page-details-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "seo",
        "queries",
        "inboundLinks",
        "internalLinks",
        "siteSpeed"
      ],
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "page-details-ui",
    "version": "1"
  },
  "detailsLibInteraction": {
    "name": "details-lib-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-back-breadcrumb",
        "clicked-open-more-details-panel",
        "clicked-edit-title-button",
        "changed-reporting-date-range-filter",
        "changed-reporting-frequency-filter",
        "changed-source-table-columns",
        "clicked-open-source-table-columns-switcher"
      ]
    },
    "namespace": "content-management-details-lib",
    "version": "1"
  }
};